import Loading from 'components/FullScreenLoading';
import StudentExamCard from 'components/StudentExamCard';
import _ from 'lodash';
import {useEffect, useState} from 'react';
import SERVICES from 'services';

export interface IExamData {
	academicYearID: number;
	academicYearName: string;
	courseID: number;
	courseName: string;
	creationDate: string;
	examCategoryID: number;
	examCategoryName: string;
	examDate: string;
	examStatusID: 1 | 2 | 3 | 4;
	examStatusName: string;
	examTypeID: number;
	examTypeName: string;
	examsGroupFlowDistributeTypeID: number;
	facultiesNames: string;
	flowsNames: string;
	groupsNames: string;
	id: number;
	maxGrade: number;
	minGrade: number;
	semesterID: number;
	semesterName: string;
	show_data: boolean;
	status: number;
	statusName: string;
	subjectID: number;
	subjectName: string;
	subjectTypeID: number;
	subjectTypeName: string;
	classroomName?: string;
	tableNumber?: string;
	mark?: string;
	consultation: {
		consultationDate: string;
		consultationClassroomName: string;
		mark: number;
	};
}

enum EXAM_PREV_STATUSES {
	WAITING = 1,
	STARTED = 2,
	APPEALING = 3,
	FINISHED = 4
}

enum EXAM_STATUSES {
	WAITING = 1,
	WAITING_2 = 2,
	CHECKING = 3,
	APPEALING = 4,
	MARKED = 5,
	FINISHED = 6,
	FINISHED_APPEALED = 7
}

enum EXAM_STATUS_NAMES {
	WAITING = 'սպասվում է',
	WAITING_2 = 'սպասվում է',
	CHECKING = 'ստուգվում է',
	APPEALING = 'բողոքարկվում է',
	MARKED = 'գնահատված',
	FINISHED = 'ավարտված',
	FINISHED_APPEALED = 'ավարտված'
}

const cardInfoSample: {
	[K in EXAM_STATUSES]: {key: keyof IExamData; title: string; type: 'string' | 'date' | 'object'}[];
} = {
	[EXAM_STATUSES.WAITING]: [
		// Սպասման մեջ
		{
			type: 'string',
			key: 'examStatusName',
			title: 'Կարգավիճակ՝'
		},
		{
			type: 'date',
			key: 'examDate',
			title: 'Քննության ամսաթիվ՝'
		}
	],
	[EXAM_STATUSES.WAITING_2]: [
		// Սպասման մեջ 2
		{
			type: 'string',
			key: 'examStatusName',
			title: 'Կարգավիճակ՝'
		},
		{
			type: 'date',
			key: 'examDate',
			title: 'Քննության ամսաթիվ՝'
		},
		{
			type: 'string',
			key: 'classroomName',
			title: 'Լսարան՝'
		},
		{
			type: 'string',
			key: 'tableNumber',
			title: 'Սեղան՝'
		}
	],
	[EXAM_STATUSES.CHECKING]: [
		// Ստուգվում է
		{
			type: 'string',
			key: 'examStatusName',
			title: 'Կարգավիճակ՝'
		},
		{
			type: 'date',
			key: 'examDate',
			title: 'Քննության ամսաթիվ՝'
		},
		{
			type: 'string',
			key: 'classroomName',
			title: 'Լսարան՝'
		},
		{
			type: 'string',
			key: 'tableNumber',
			title: 'Սեղան՝'
		}
	],
	[EXAM_STATUSES.MARKED]: [
		// Գնահատված է
		{
			type: 'string',
			key: 'examStatusName',
			title: 'Կարգավիճակ՝'
		},
		{
			type: 'date',
			key: 'examDate',
			title: 'Քննության ամսաթիվ՝'
		},
		{
			type: 'string',
			key: 'classroomName',
			title: 'Լսարան՝'
		},
		{
			type: 'string',
			key: 'tableNumber',
			title: 'Սեղան՝'
		},
		{
			type: 'string',
			key: 'mark',
			title: 'Գնահատական՝'
		}
	],
	[EXAM_STATUSES.APPEALING]: [
		// Բողոքարկվում է
		{
			type: 'string',
			key: 'examStatusName',
			title: 'կարգավիճակ՝'
		},
		{
			type: 'date',
			//@ts-ignore
			key: 'consultation.consultationDate',
			title: 'Բողոքարկման ամսաթիվ՝'
		},
		{
			type: 'string',
			//@ts-ignore
			key: 'consultation.consultationClassroomName',
			title: 'Լսարան՝'
		}
	],
	[EXAM_STATUSES.FINISHED]: [
		// Ավարտված
		{
			type: 'string',
			key: 'examStatusName',
			title: 'կարգավիճակ՝'
		},
		{
			type: 'date',
			key: 'examDate',
			title: 'Քննության ամսաթիվ՝'
		},
		{
			type: 'string',
			key: 'classroomName',
			title: 'Լսարան՝'
		},
		{
			type: 'string',
			key: 'tableNumber',
			title: 'Սեղան՝'
		},
		{
			type: 'string',
			key: 'mark',
			title: 'Գնահատական`'
		}
	],
	[EXAM_STATUSES.FINISHED_APPEALED]: [
		// Ավարտված
		{
			type: 'string',
			key: 'examStatusName',
			title: 'կարգավիճակ՝'
		},
		{
			type: 'date',
			key: 'examDate',
			title: 'Քննության ամսաթիվ՝'
		},
		{
			type: 'string',
			key: 'classroomName',
			title: 'Լսարան՝'
		},
		{
			type: 'string',
			key: 'tableNumber',
			title: 'Սեղան՝'
		},
		{
			type: 'string',
			//@ts-ignore
			key: 'consultation.mark',
			title: 'Գնահատական`'
		}
	]
};

export interface IComputedExamData {
	id: number;
	subjectName: string;
	examTypeName: string;
	cardInfo: Array<{
		value: string;
		title: string;
		type: 'string' | 'date' | 'object';
	}>;
	actions: Array<{
		action: (...params: any) => Promise<any>;
		title: string;
	}>;
	appealing: boolean;
}

const examHelper = (
	i: IExamData,
	k: {
		key: keyof IExamData;
		title: string;
		type: 'string' | 'date' | 'object';
	},
	statusName: EXAM_STATUS_NAMES
) => {
	if (k.key !== 'examStatusName') {
		const value = _.get(i, k.key, '')?.toString() || 'նշանակված չէ';
		const type = value && value !== 'նշանակված չէ' ? k.type : 'string';
		return {
			title: k.title,
			value,
			type
		};
	}
	return {
		title: k.title,
		value: statusName as string,
		type: 'string' as 'string'
	};
};

const Exams = () => {
	const [data, setData] = useState<IComputedExamData[] | null>(null);

	useEffect(() => {
		SERVICES.USER.getExams('STUDENT').then((res: {data: IExamData[]}) => {
			const computedData: IComputedExamData[] = res.data.map(i => {
				const cardInfo: IComputedExamData['cardInfo'] = [];
				const actions: IComputedExamData['actions'] = [];

				switch (i.examStatusID as EXAM_PREV_STATUSES) {
					case EXAM_PREV_STATUSES.WAITING:
						cardInfo.push(
							...cardInfoSample[EXAM_STATUSES.WAITING].map(k =>
								examHelper(i, k, EXAM_STATUS_NAMES.WAITING)
							)
						);
						break;
					case EXAM_PREV_STATUSES.STARTED:
						cardInfo.push(
							...cardInfoSample[EXAM_STATUSES.WAITING_2].map(k =>
								examHelper(i, k, EXAM_STATUS_NAMES.WAITING_2)
							)
						);
						break;
					case EXAM_PREV_STATUSES.APPEALING:
						if (i.mark === undefined) {
							cardInfo.push(
								...cardInfoSample[EXAM_STATUSES.CHECKING].map(k =>
									examHelper(i, k, EXAM_STATUS_NAMES.CHECKING)
								)
							);
						}
						if (i.mark !== undefined && Object.keys(i.consultation).length === 0) {
							cardInfo.push(
								...cardInfoSample[EXAM_STATUSES.MARKED].map(k =>
									examHelper(i, k, EXAM_STATUS_NAMES.MARKED)
								)
							);
							actions.push({
								title: 'Գրանցվել կոնսուլտացիայի',
								action: () => SERVICES.USER.regToConsultation(i.id)
							});
						}
						if (i.mark !== undefined && Object.keys(i.consultation).length > 0) {
							cardInfo.push(
								...cardInfoSample[EXAM_STATUSES.APPEALING].map(k =>
									examHelper(i, k, EXAM_STATUS_NAMES.APPEALING)
								)
							);
						}
						break;
					case EXAM_PREV_STATUSES.FINISHED:
						cardInfo.push(
							...cardInfoSample[EXAM_STATUSES.FINISHED].map(k =>
								examHelper(i, k, EXAM_STATUS_NAMES.FINISHED)
							)
						);
						break;
				}

				return {
					id: i.id,
					subjectName: i.subjectName,
					examTypeName: i.examTypeName,
					appealing: i.mark !== undefined && Object.keys(i.consultation).length === 0,
					cardInfo,
					actions
				};
			});

			setData(computedData);
		});
	}, []);

	if (data === null) return <Loading />;

	if (data.length === 0)
		return <div style={{justifySelf: 'center', alignSelf: 'center'}}>Դուք դեռ չունեք քննություններ</div>;

	return (
		<div className="exam-container">
			{data.map(i => (
				<StudentExamCard data={i} key={i.id} />
			))}
		</div>
	);
};

export default Exams;
